import React, { useState } from "react";
import ReactDOM from "react-dom";
import Icon from "components/ui/Icon";
import Logo from "components/ui/Logo";
import { colors } from "utils/theme";
import * as Styled from "./styled";
import { BaseButton, ButtonLevel, ButtonSize } from "../Button";
import ExportDataButton from "./ExportDataButton";
import { NAVIGATION } from "./constants";
import MobileLinks from "./MobileLinks";
import { getPath } from "./utils";

const AdminNavigation: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <Styled.Wrapper>
        <Styled.NavInner>
          <Styled.LogoWrapper>
            <Logo />
          </Styled.LogoWrapper>

          <Styled.NavItems>
            {NAVIGATION.map((item) => (
              <Styled.NavItem key={item.title} $hideMobile={item.hideMobile}>
                <Styled.NavLink to={getPath(item.path)} end>
                  <Icon name={item.icon} color={colors.white} />
                  <Styled.Label>{item.title}</Styled.Label>
                  <Styled.ShortLabel>
                    {item.shortTitle || item.title}
                  </Styled.ShortLabel>
                </Styled.NavLink>
              </Styled.NavItem>
            ))}

            <Styled.MobileMenuButton>
              <BaseButton onClick={() => setIsDrawerOpen(true)}>
                <Icon name="ellipsisVertical" size="md" />
              </BaseButton>
            </Styled.MobileMenuButton>

            <Styled.ExportDataButtonWrapper>
              <ExportDataButton />
            </Styled.ExportDataButtonWrapper>
          </Styled.NavItems>

          <Styled.Footer>
            <Styled.AdminButtonLink
              href="/dashboard"
              size={ButtonSize.md}
              level={ButtonLevel.ghost}
            >
              Dashboard
            </Styled.AdminButtonLink>
          </Styled.Footer>
        </Styled.NavInner>
      </Styled.Wrapper>

      {ReactDOM.createPortal(
        <MobileLinks
          isOpen={isDrawerOpen}
          closeDrawer={() => setIsDrawerOpen(false)}
        />,
        document.body
      )}
    </>
  );
};

export default AdminNavigation;
